module.exports = __webpack_public_path__ + "media/images/companyPage/education-210e5319c61b7a661aaf52303eddd636.svg";